// ── 예외 스케줄 등록 창 — 달력 화면 밖에서 여는 한 벌 (2026-09-29) ─────────────────────────
//   사용자: ☰ 메뉴의 "예외 스케줄 등록"을 달력·직원별 상세 두 탭에서 **같이**. 달력 탭은 원래 창(useAttendanceCalendar)을
//   그대로 쓰고, 직원별 상세 탭은 이 한 벌로 **그 자리에서** 연다(탭을 옮기지 않는다).
//   저장 주소·규칙은 달력과 같다: POST {calendarApiBase}/overrides (날짜마다 1건). 새로 등록만 — 수정·삭제는 달력에서.
//   직원 목록·근무지 목록은 열 때 달력과 같은 곳에서 한 번 불러온다(이번 달 달력 응답의 employees, /ip-aliases).
import React, { useState } from 'react';
import { apiClient } from '../../../api/apiClient';
import { useToast } from '../../../components/Toast';
import { nowKST } from '../../../utils/date';
import { OverrideModal } from './OverrideModal';

export function useOverrideRegister({ calendarApiBase, onSaved } = {}) {
  const { showToast } = useToast();
  const [modal, setModal] = useState(null);
  const [employees, setEmployees] = useState(null);
  const [ipAliases, setIpAliases] = useState([]);

  function open() {
    if (!calendarApiBase) return;
    setModal({});
    if (employees === null) {
      const n = nowKST(); // utils/date.js (new Date 직접 사용 금지)
      apiClient.get(`${calendarApiBase}?year=${n.getUTCFullYear()}&month=${n.getUTCMonth() + 1}`)
        .then((r) => setEmployees(r.ok ? (r.data?.data?.employees || []) : []))
        .catch(() => setEmployees([]));
      apiClient.get(`${calendarApiBase}/ip-aliases`)
        .then((r) => { if (r.ok && r.data?.success) setIpAliases(r.data.aliases || []); })
        .catch(() => {});
    }
  }

  // 달력 useAttendanceCalendar.handleOverrideSave 와 같은 저장 — 실패하면 창이 오류를 띄운다(OverrideModal)
  async function save(payloads) {
    const list = Array.isArray(payloads) ? payloads : [payloads];
    for (const payload of list) {
      const res = await apiClient.post(`${calendarApiBase}/overrides`, payload);
      if (!res.ok) throw new Error(res.data?.message || '저장 실패');
    }
    showToast(`예외 스케줄 ${list.length}건이 등록되었습니다.`);
    if (onSaved) onSaved();
  }

  const modalNode = modal !== null ? (
    <OverrideModal
      modal={modal}
      employees={employees || []}
      ipAliases={ipAliases}
      onClose={() => setModal(null)}
      onSave={save}
      onDelete={null}
    />
  ) : null;

  return { open, modal: modalNode, available: Boolean(calendarApiBase) };
}
